<!-- Date Range Input -->
@if (enableRangeSelection) {
  <mat-form-field appearance="outline" [floatLabel]="floatLabel ? 'always' : 'auto'">
    <mat-label>{{ label }}</mat-label>
    <mat-date-range-input [max]="maxDate" [min]="minDate" [rangePicker]="picker" >
      <input matStartDate [formControl]="startDateControl" [readonly]="readonly">
      <input matEndDate [formControl]="endDateControl" [readonly]="readonly">
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="picker" />
    <mat-date-range-picker #picker />
  </mat-form-field>
}

<!-- Single Date Input -->
@if (!enableRangeSelection) {
  <mat-form-field appearance="outline" [floatLabel]="floatLabel ? 'always' : 'auto'">
    <mat-label [id]="idPrefix + '-label'" >{{label}}</mat-label>
    <input matInput [errorStateMatcher]="matcher" [formControl]="formControl" [id]="idPrefix + '-input'" [matDatepicker]="picker"  [max]="maxDate"
      [min]="minDate"
      [placeholder]="placeholder"
      [readonly]="readonly">
    <mat-datepicker-toggle matIconSuffix [disabled]="readonly || disabled" [for]="picker" />
    <mat-datepicker #picker />
    <mat-hint [id]="idPrefix + '-hint'">{{hint}}</mat-hint>
    @if (formControl && formControl.invalid) {
      <mat-error [id]="idPrefix + '-error'" [innerHTML]="errors" />
    }
  </mat-form-field>
}
